import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { CanActivate } from '@angular/router';
import { XhrService } from './xhr.service';
import { Auth } from '../shared/auth';

import { TranslateService } from '@ngx-translate/core';

import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate, OnInit, OnDestroy {

  auth: Auth;
  getUser;
  lastUrl;
  constructor(private xhrService: XhrService,
    private route: ActivatedRoute,
    //public toast:ToastService,
    private translate: TranslateService,
    private router: Router, ) {

    if (window.localStorage.getItem('auth')) {
      this.auth = JSON.parse(window.localStorage.getItem('auth'));
    } else {
      this.auth = new Auth();
    }
    this.getInfo();
    this.lastUrl='';
  }
  getInfo() {
    this.xhrService.get('auth/getInfo').subscribe(
      items => {
        this.auth = items.token
        window.localStorage.setItem("Token", this.auth._id);
        window.localStorage.setItem("auth", JSON.stringify(this.auth));
        if(this.xhrService.token != '' && this.xhrService.token != this.auth._id){
          this.xhrService.token = this.auth._id;
          this.router.navigate(['auth/login']);
        }else{
          this.xhrService.token = this.auth._id;
        }
        
      }, err => {
        // Log errors if any
        //console.log(err);
        //this.toast.showErrorCode(err.code);
      });
  }
  canActivate(route) {

    if(this.auth.loginFlag){
      if(this.checkPagePermission(route.data['page'],route.data['operation'])){
        return true;
      }else{
        return false;
      }
      
    }
    this.lastUrl=route._routerState.url;
    
    this.router.navigate(['auth/login']);
    return false;
    
    
  }
  checkPagePermission(route,page="_access") {
    var r = route.split(".");

    if (this.auth &&
      this.auth.role &&
      this.auth.role.permission &&
      this.auth.role.permission.page &&
      this.auth.role.permission.page[r[0]] &&
      this.auth.role.permission.page[r[0]][r[1]]) {
      return this.auth.role.permission.page[r[0]][r[1]][page]
    }
    return false;
  }

  login(fAuth) {
    var data = { auth: null, method: null };
    data.auth = fAuth;
    data.method = 'auth.login';
    return this.xhrService.post('auth/login', data).map(
      items => {
        this.auth = items.token
        window.localStorage.setItem("Token", this.auth._id);
        window.localStorage.setItem("auth", JSON.stringify(this.auth));
        this.xhrService.token = this.auth._id;
        if(this.lastUrl == ''){
          this.router.navigate(['admin/dashboard']);
        }else{
          this.router.navigate([this.lastUrl]);
          this.lastUrl='';
        }
        
      });
  }
  signup(fAuth) {
    var data = { auth: null, method: null };
    data.auth = fAuth;
    data.method = 'auth.register';
    return  this.xhrService.post('auth/register', data).map(
      items => {
        this.auth = items.token;
        window.localStorage.setItem("Token", this.auth._id);
        window.localStorage.setItem("auth", JSON.stringify(this.auth));
        this.xhrService.token = this.auth._id;
      });
  }
  forgetPassword(fAuth) {
    var data = { auth: null, method: null };
    data.auth = fAuth;
    data.method = 'auth.forget';
    return this.xhrService.post('auth/forgetPassword', data).map(
      items => {
        this.logout()
      });
  }
  changePassword(fAuth) {
    var data = { auth: null, method: null };
    data.auth = fAuth;
    data.method = 'auth.changePassword';
    return this.xhrService.post('auth/changePassword', data).map(
      items => {
        this.logout()
      });
  }
  changePasswordI(fAuth) {
    var data = { auth: null, method: null };
    data.auth = fAuth;
    data.method = 'auth.changePassword';
    return this.xhrService.post('auth/changePasswordI', data).subscribe(
      items => {
        //this.toast.showSuccess(this.translate.instant('auth.common.changePasswordM'));
      }, err => {
        // Log errors if any
        //console.log(err);
        //this.toast.showErrorCode(err.code);
      });
  }

  logout() {

    if (this.auth && this.auth.loginFlag) {
      var data = { method: 'auth.logout' };
      data['auth'] = this.auth;
      this.xhrService.post('auth/logout', data).subscribe(
        items => items, err => err);
    }

    window.localStorage.removeItem("Token");
    window.localStorage.removeItem("auth");

    this.xhrService.token = '';
    this.getInfo();
    this.router.navigate(['auth/login']);
  }

  ngOnInit() {

  }

  ngOnDestroy() {


  }
}


// WEBPACK FOOTER //
// ./src/app/service/auth-guard.service.ts